import React, { useState, useEffect } from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles/index";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Accordion from "./Accordion"

const useStyles = makeStyles({
  list: {
    width: 400,
    height: "100vh",
  },
  card: {
    margin: "30px",
  },
  pointer: {
    cursor: "pointer",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#005488",
  },
});
const initialValues = {
  name: "",
  permissionIds: "",
};
function Edit(props) {
  const classes = useStyles();
  const { onHide, show, id, onRoles, onRoleChoose } = props;

  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [oldValue, setOldValue] = useState([]);

  const onPutRole = (values, resetForm, setSubmitting) => {
    setIsEditLoading(true);

    const roleParam = {
      id: id,
      name: values.name,
    };
    const roleBody = {
      permissionIds: oldValue,
    };
    axios
      .put(`${process.env.REACT_APP_API_URL}role/${id}?name=${roleParam.name}`, roleBody)
      .then(() => {
        resetForm();
        onRoles();
        setSubmitting(false);
        setIsEditLoading(false);
        onHide(false);
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        setIsError(message);
        setIsEditLoading(false);
      });
  };

  const EditSchema = Yup.object().shape({
    name: Yup.string().required("Ad tələb olunur"),

  });

  const getInputClasses = (touched, errors, filedName) => {
    if (touched[filedName] && errors[filedName]) {
      return true;
    }

    if (touched[filedName] && errors[filedName]) {
      return false;
    }

    return false;
  };

  const formik = useFormik({
    initialValues,
    validationSchema: EditSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPutRole(values, resetForm, setSubmitting);
    },
  });

  const { setFieldValue } = formik;

  useEffect(() => {
    setIsLoading(true);
    onRoleChoose(id)
      .then((res) => {
     
        const oldValue = res.data.permission.map(
          ({ id }) => id
        );
        setOldValue(oldValue);
        setFieldValue("name", res.data.name ? res.data.name : "");
        setFieldValue(
          "permissionIds",
          res.data.permissionIds ? res.data.permissionIds : ""
        );

        setIsLoading(false);
        setIsError(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [id, setFieldValue]);





  const [user, setUser] = useState([]);
  const [card, setCard] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [deviceModel, setDeviceModel] = useState([]);
  const [devicePlace, setDevicePlace] = useState([]);
  const [deviceType, setDeviceType] = useState([]);
  const [duty, setDuty] = useState([]);
  const [structure, setStructure] = useState([]);
  const [limit, setLimit] = useState([]);
  const [role, setRole] = useState([]);
  const [employeeReport, setEmployeeReport] = useState([]);
  const [employeeBiometricReport, setEmployeeBiometricReport] = useState([]);
  const [deviceOperationReport, setDeviceOperationReport] = useState([]);
  const [deviceReport, setDeviceReport] = useState([]);
  const [syncData, setSyncData] = useState([]);
  const [device, setDevice] = useState([]);
  const [deviceUser, setDeviceUser] = useState([]);





  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}permission`)
      .then((res) => {
        const displayTypes = res.data.map(({ id, description, type }) => ({
          value: id,
          label: description,
          type: type
        }))

        const newUser = displayTypes.filter(obj => {
          return obj.type === 'user';
        });
        const newCard = displayTypes.filter(obj => {
          return obj.type === 'card';
        });
        const newEmployees = displayTypes.filter(obj => {
          return obj.type === 'employees';
        });
        const newDeviceModel = displayTypes.filter(obj => {
          return obj.type === 'device_model';
        });
        const newDevicePlace = displayTypes.filter(obj => {
          return obj.type === 'device_place';
        });
        const newDeviceType = displayTypes.filter(obj => {
          return obj.type === 'device_type';
        });
        const newDuty = displayTypes.filter(obj => {
          return obj.type === 'duty';
        });
        const newStructure = displayTypes.filter(obj => {
          return obj.type === 'structure';
        });
        const newLimit = displayTypes.filter(obj => {
          return obj.type === 'limit';
        });
        const newRole = displayTypes.filter(obj => {
          return obj.type === 'role';
        });
        const newEmployeesReport = displayTypes.filter(obj => {
          return obj.type === 'employee_report';
        });
        const newEmployeeBiometricReport = displayTypes.filter(obj => {
          return obj.type === 'employee_biometric_report';
        });
        const newDeviceOperationReport = displayTypes.filter(obj => {
          return obj.type === 'device_operation_report';
        });
        const newDeviceReport = displayTypes.filter(obj => {
          return obj.type === 'device_report';
        });
        const newSyncData = displayTypes.filter(obj => {
          return obj.type === 'sync_data';
        });
        const newDevice = displayTypes.filter(obj => {
          return obj.type === 'devices';
        });
        const newDeviceUser= displayTypes.filter(obj => {
          return obj.type === 'device_user';
        });
        setUser(newUser);
        setCard(newCard);
        setEmployees(newEmployees)
        setDeviceModel(newDeviceModel)
        setDevicePlace(newDevicePlace)
        setDeviceType(newDeviceType)
        setDuty(newDuty)
        setStructure(newStructure)
        setLimit(newLimit)
        setRole(newRole)
        setEmployeeReport(newEmployeesReport)
        setEmployeeBiometricReport(newEmployeeBiometricReport)
        setDeviceOperationReport(newDeviceOperationReport)
        setDeviceReport(newDeviceReport)
        setSyncData(newSyncData)
        setDevice(newDevice)
        setDeviceUser(newDeviceUser)

      });
  }, []);


  return (
    <Modal
      size="md"
      onHide={onHide}
      show={show}
      aria-labelledby="edit"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="edit">Düzəliş et</Modal.Title>
      </Modal.Header>
      {isLoading ? (
        <div className={classes.progresRoot}>
          <CircularProgress className={classes.progress} />
        </div>
      ) : !isLoading && !isError ? (
        <form onSubmit={formik.handleSubmit}>
          <Modal.Body className="log-body-modal">
            <div className="col-12 pl-4 pr-4 ">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-12">
                  <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                    {isError && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block MuiFormLabel-root Mui-error">
                          {isError}
                        </div>
                      </div>
                    )}
                    <TextField
                      id="name"
                      label="Ad"
                      placeholder="Ad"
                      className="w-100"
                      error={getInputClasses("name")}
                      {...formik.getFieldProps("name")}
                    />
                  </div>
                  {formik.touched.name && formik.errors.name ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{formik.errors.name}</div>
                    </div>
                  ) : null}
                </div>
                <div className="col-12 col-md-12 col-lg-12">
                  <Accordion data={user} title="İstifadəçilər" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={card} title="Kartlar" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={employees} title="İnsan resursları" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={deviceModel} title="Qurğu modeli" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={deviceType} title="Qurğu tipi" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={devicePlace} title="Qurğu məkanı" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={structure} title="Daxili struktur" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={duty} title="Vəzifələr" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={limit} title="Barmaq izi və kart limit" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={role} title="Rollar" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={employeeReport} title="Əməkdaşlar üzrə hesabat" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={employeeBiometricReport} title="Biometrik Əməkdaşlar üzrə hesabat" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={deviceOperationReport} title="Qurğu əməliyyat hesabatı" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={deviceReport} title="Qurğular hesabatı" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={syncData} title="Sinxronizasiya ayarları" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={device} title="Qurğular" setOldValue={setOldValue} oldValue={oldValue} />
                  <Accordion data={deviceUser} title="Qurğudakı əməkdaşlar" setOldValue={setOldValue} oldValue={oldValue}/>




                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                onHide(false);
                formik.resetForm();
              }}
            >
              Bağla
            </Button>
            <Button type="submit" className={isEditLoading ? "px-9" : ""}>
              <span>Düzəliş et</span>
              {isEditLoading && (
                <span className="ml-3 spinner spinner-white"></span>
              )}
            </Button>
          </Modal.Footer>
        </form>
      ) : (
        <div className="p-5">
          <Alert variant="info">Xəta baş verdi.</Alert>
        </div>
      )}
    </Modal>
  );
}


export default Edit;
